module.exports = __webpack_public_path__ + "static/media/tweet.aee553a1.png";